import React from "react";

const Backdrop = () => {
  return (
    <div className="fixed -z-[999] pointer-events-none top-0 right-0 bottom-0 left-0 bg-white" />
  );
};

export default Backdrop;
